module.exports = __webpack_public_path__ + "img/fav-white.7042a855.png";